module.exports = ".reorder-button{font-size:20px;color:#003b8b}.reorder-button-disabled{font-size:20px;color:grey}\n"